import { render, staticRenderFns } from "./change-payment-type-form.vue?vue&type=template&id=b6d3bc92&"
import script from "./change-payment-type-form.vue?vue&type=script&lang=js&"
export * from "./change-payment-type-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports